export const HOME = "/";
export const APPLICATION = "/application";
export const LANDING = "/landing";
export const DOCUMENTS = "/documents";
export const ADMIN = "/admin";
export const APPLICATION_SIGNATURE = "/signature/:applyId";
export const APPLICATION_SIGNATURE_SUCCESS = "/signature/:applyId/success";
